import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
    
    .anuncio
    {
        width: 86%; 
        height: 175px;
        margin-top: 40px;
        margin-left: 7%;
        background-color: #C4C4C4;
        cursor: 'pointer';
    }
`;


function Anuncio(props){
    return(
        <Div>
            <a href={(props.dados.link)? props.dados.link: '#'} target="_blank">
            {props.dados.img &&(
                    <img src={`https://inaarees.gov.ao/backend/u/${props.dados.img}`} className="anuncio"/>
                )
            }
            </a>
        </Div>
    );
}

export default Anuncio;